<template>
  <div class="elementor-element elementor-element-4fca4e3f e-flex e-con-boxed e-con e-parent" data-id="4fca4e3f"
    data-element_type="container"
    data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}"
    data-core-v316-plus="true">
    <div class="e-con-inner">
      <div class="elementor-element elementor-element-24abef56 e-con-full e-flex e-con e-child" data-id="24abef56"
        data-element_type="container"
        data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
        <div class="elementor-element elementor-element-23cc6ebb elementor-widget elementor-widget-heading"
          data-id="23cc6ebb" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">Start to</h2>
          </div>
        </div>
        <div class="elementor-element elementor-element-4ac90a32 elementor-widget elementor-widget-heading"
          data-id="4ac90a32" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">Trade With Confidence</h2>
          </div>
        </div>
        <div class="elementor-element elementor-element-5c38114f elementor-widget elementor-widget-text-editor"
          data-id="5c38114f" data-element_type="widget" data-widget_type="text-editor.default">
          <div class="elementor-widget-container">
            <p>On Our Transparent &amp; Hassle-Free Platform</p>
          </div>
        </div>
      </div>

      <div class="elementor-element elementor-element-946a323 e-con-full e-flex e-con e-child" data-id="946a323"
        data-element_type="container"
        data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
        <!-- Demo Account -->
        <div class="elementor-element elementor-element-72037eac e-con-full e-flex e-con e-child" data-id="72037eac"
          data-element_type="container"
          data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
          <div
            class="elementor-element elementor-element-3026355a elementor-view-default elementor-widget elementor-widget-image"
            data-id="3026355a" data-element_type="widget" data-widget_type="image.default">
            <div class="elementor-widget-container">
              <img decoding="async" width="120" height="120" src="/assets/img/demo-img.png"
                class="attachment-full size-full" alt="Demo Account" style="width:120px;height:auto" />
            </div>
          </div>
          <div
            class="elementor-element elementor-element-3b1e83d6 elementor-align-justify elementor-mobile-align-center elementor-justify-between elementor-widget elementor-widget-button"
            data-id="3b1e83d6" data-element_type="widget" data-widget_type="button.default">
            <div class="elementor-widget-container">
              <div class="elementor-button-wrapper">
                <router-link class="elementor-button elementor-button-link elementor-size-sm" to="/signup">
                  <span class="elementor-button-content-wrapper">
                    <span class="elementor-button-text">Demo Account</span>
                  </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- OR Divider -->
        <div class="elementor-element elementor-element-79f758c8 e-con-full e-flex e-con e-child" data-id="79f758c8"
          data-element_type="container"
          data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
          <div class="elementor-element elementor-element-174fdeb3 elementor-widget elementor-widget-heading"
            data-id="174fdeb3" data-element_type="widget" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <h2 class="elementor-heading-title elementor-size-default">OR</h2>
            </div>
          </div>
        </div>

        <!-- Real Account -->
        <div class="elementor-element elementor-element-47ec92b1 e-con-full e-flex e-con e-child" data-id="47ec92b1"
          data-element_type="container"
          data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
          <div
            class="elementor-element elementor-element-3011c7fd elementor-view-default elementor-widget elementor-widget-image"
            data-id="3011c7fd" data-element_type="widget" data-widget_type="image.default">
            <div class="elementor-widget-container">
              <img decoding="async" width="120" height="120" src="/assets/img/real-img.png"
                class="attachment-full size-full" alt="Real Account" style="width:120px;height:auto" />
            </div>
          </div>
          <div
            class="elementor-element elementor-element-6f514175 elementor-align-justify elementor-widget elementor-widget-button"
            data-id="6f514175" data-element_type="widget" data-widget_type="button.default">
            <div class="elementor-widget-container">
              <div class="elementor-button-wrapper">
                <router-link class="elementor-button elementor-button-link elementor-size-sm" to="/signup">
                  <span class="elementor-button-content-wrapper">
                    <span class="elementor-button-text">Real Account</span>
                  </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingCallToAction'
}
</script>

<style scoped>
.elementor-element-47ec92b1 {
  justify-content: space-between;
}
</style>